import { Model } from "../mvvm/Model.js";
/** Ticket is an OOP model for a support ticket with domain-level validation. */
export class Ticket extends Model {
    id;
    type;
    description;
    status;
    createdAt;
    constructor(id, type, description, status, createdAt) {
        super();
        this.id = id;
        this.type = type;
        this.description = description;
        this.status = status;
        this.createdAt = createdAt;
    }
    validate() {
        const errors = [];
        if (this.id.trim() === "")
            errors.push("Ticket id is required.");
        if (this.description.trim() === "")
            errors.push("Description is required.");
        return errors;
    }
    get isOpen() {
        return this.status === "open";
    }
    get displayType() {
        return this.type === "feature" ? "Feature Request" : "Issue";
    }
}
//# sourceMappingURL=Ticket.js.map